const fonts = {
  light: `font-family: 'Ubuntu'; font-weight: 300;`,
  reg: `font-family: 'Ubuntu'; font-weight: 400;`,
  bold: `font-family: 'Ubuntu'; font-weight: 700;`,
};

export default fonts;
